import { render, staticRenderFns } from "./outline-gray-button.vue?vue&type=template&id=5e4295da&scoped=true&"
import script from "./outline-gray-button.vue?vue&type=script&lang=js&"
export * from "./outline-gray-button.vue?vue&type=script&lang=js&"
import style0 from "./outline-gray-button.vue?vue&type=style&index=0&id=5e4295da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4295da",
  null
  
)

export default component.exports